import React from 'react'
import { motion } from 'framer-motion'
import data from '../assets/data.json'
import { FiExternalLink } from 'react-icons/fi'

const Work = () => {
  return (
    <div id='work'>
      <div className="workHeader">
        <p className="section-label">Portfolio</p>
        <h2 className="section-title">Featured Projects</h2>
        <p className="workSubtitle">
          A selection of projects I've built — from payment platforms to data analytics tools.
        </p>
      </div>

      <div className="projectGrid">
        {data.projects.map((project, i) => (
          <motion.article
            className="projectCard"
            key={project.title}
            initial={{ y: 40, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
          >
            <div className="projectImg">
              <img src={project.imgSrc} alt={project.title} loading="lazy" />
              {project.url !== '#' && (
                <a href={project.url} target="_blank" rel="noreferrer" className="projectLink">
                  <FiExternalLink />
                </a>
              )}
            </div>
            <div className="projectInfo">
              <span className="projectDate">{project.date}</span>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              {project.tags && (
                <div className="projectTags">
                  {project.tags.map(tag => (
                    <span key={tag} className="tag">{tag}</span>
                  ))}
                </div>
              )}
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  )
}

export default Work